import React from "react";
import { Oval } from "react-loader-spinner";

import { useAppSelector, useAppDispatch } from "../../../../app/hooks";
import { YearPicker } from "../../../../components";
import { YearlyCard } from "../../components";
import { getYearlyReport } from "../../reportsSlice";

import "./YearlyReportView.scss";

export const YearlyReportView: React.FC = () => {
  const dispatch = useAppDispatch();

  const getYearlyReportAPI = useAppSelector(
    (state) => state.reports.getYearlyReportAPI
  );
  const yearlyReport = useAppSelector((state) => state.reports.yearlyReport);

  const [year, setYear] = React.useState<number>(new Date().getFullYear());

  React.useEffect(() => {
    dispatch(getYearlyReport(year + ""));
  }, [year]);

  return (
    <div className="yearly-report-view-component">
      <div className="title-container">
        <div className="title-row">
          <div className="title-text">Yearly Report</div>

          {getYearlyReportAPI.loading && (
            <div style={{ marginLeft: 8 }}>
              <Oval
                color="#131313"
                height={20}
                width={20}
                secondaryColor="#0A60BB"
              />
            </div>
          )}
        </div>

        <YearPicker initialYear={year} onYearChange={setYear} />
      </div>

      {yearlyReport && <YearlyCard months={yearlyReport.orders} />}
    </div>
  );
};
